import React from 'react'
import { Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'

export interface Tab {
  id: string
  label: string
  icon?: React.ReactNode
  badge?: number | string
}

interface TabNavigationProps {
  tabs: readonly Tab[]
  activeTab: string
  onTabChange: (tabId: string) => void
  ghost?: boolean
}

export const TabNavigation = ({
  tabs,
  activeTab,
  onTabChange,
  ghost = false,
}: TabNavigationProps) => {
  return (
    <Row
      className={cn(
        'w-fit flex-wrap gap-1.5 rounded-[var(--radius-outer)] border p-2',
        'border-[hsl(var(--border-subtle))] bg-[hsl(var(--surface-panel)/0.88)] backdrop-blur-md',
        ghost && 'bg-[hsl(var(--tab-track-ghost)/0.92)]'
      )}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex items-center gap-2 whitespace-nowrap rounded-[var(--radius-tab)] px-3.5 py-2 text-sm font-medium transition-all duration-200',
              isActive
                ? 'button-secondary text-foreground'
                : 'text-muted-foreground hover:bg-black/[0.045] hover:text-foreground/80'
            )}
          >
            {tab.icon && (
              <span
                className={cn(
                  'shrink-0',
                  isActive ? 'text-foreground' : 'text-muted-foreground'
                )}
              >
                {tab.icon}
              </span>
            )}

            <span>{tab.label}</span>
            {tab.badge != null && Number(tab.badge) > 0 && (
              <span
                className={cn(
                  'inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full px-1 text-[0.625rem] font-medium tabular-nums',
                  isActive
                    ? 'bg-foreground text-background'
                    : 'bg-black/[0.06] text-muted-foreground'
                )}
              >
                {tab.badge}
              </span>
            )}
          </button>
        )
      })}
    </Row>
  )
}
